import { useUserInfo } from '../use-userInfo'
import { Permission as PermissionsEnum } from 'utils/permissions'
import { PERMISSIONS } from 'config/vars'

export const usePermissions = () => {
  const { user } = useUserInfo()
  const { newPermissionsManagement } = user?.featureToggles || {}

  const canManagePermissions =
    user?.permissions?.includes(PermissionsEnum.CAN_MANAGE_PERMISSIONS) &&
    newPermissionsManagement

  if (newPermissionsManagement) {
    const canManageUsers = user?.permissions?.includes(
      PermissionsEnum.CAN_MANAGE_USERS
    )

    const canDeleteUsers = user?.permissions?.includes(
      PermissionsEnum.CAN_DELETE_USERS
    )

    const canManageCollections = user?.permissions?.includes(
      PermissionsEnum.CAN_MANAGE_COLLECTIONS
    )

    const canManageEntities = user?.permissions?.includes(
      PermissionsEnum.CAN_MANAGE_ENTITIES
    )

    return {
      permissions: user?.permissions || [],
      canManageUsers,
      canDeleteUsers,
      canManagePermissions,
      canManageCollections,
      canManageEntities
    }
  }

  const canManageUsers = [
    PERMISSIONS.CAN_CREATE_READER,
    PERMISSIONS.CAN_CREATE_ADMIN,
    PERMISSIONS.CAN_DELETE_READER,
    PERMISSIONS.CAN_DELETE_ADMIN,
    PERMISSIONS.CAN_ACCESS_ADMIN
  ].some(permission => user?.teacher?.permissions?.includes(permission))

  return {
    permissions: user?.teacher?.permissions || [],
    canManageUsers: canManageUsers,
    canManagePermissions: canManagePermissions,
    canManageCollections: true,
    canManageEntities: true,
    canDeleteUsers: false
  }
}
